<h2 class="text-2xl font-bold text-white text-center md:text-left">Analyse complète de la probabilité</h2>
@if (loading()) {
<div class="card mt-8 w-full md:w-2/3 mobile-padding mx-auto">
    <div class="flex items-center justify-between mb-4">
        <p-skeleton width="10rem" height="2rem"></p-skeleton>
        <p-skeleton shape="circle" size="2rem"></p-skeleton>
    </div>
    <div class="flex justify-center mt-4">
        <p-skeleton width="12rem" height="2rem"></p-skeleton>
    </div>
    <div class="flex flex-row text-center mt-4">
        <div class="w-full md:w-5/12 flex flex-col items-center justify-center py-5">
            <p-skeleton shape="circle" size="6rem"></p-skeleton>
            <p-skeleton width="6rem" class="mt-2"></p-skeleton>
            <p-skeleton width="10rem" height="0.5rem" class="mt-2"></p-skeleton>
            <p-skeleton width="4rem" class="mt-2"></p-skeleton>
        </div>

        <div class="w-full md:w-2/12 flex flex-col items-center justify-center py-5">
            <p-skeleton width="6rem" height="1.5rem"></p-skeleton>
            <p-skeleton width="4rem" height="1rem" class="mt-2"></p-skeleton>
        </div>

        <div class="w-full md:w-5/12 flex flex-col items-center justify-center py-5">
            <p-skeleton shape="circle" size="6rem"></p-skeleton>
            <p-skeleton width="6rem" class="mt-2"></p-skeleton>
            <p-skeleton width="10rem" height="0.5rem" class="mt-2"></p-skeleton>
            <p-skeleton width="4rem" class="mt-2"></p-skeleton>
        </div>
    </div>

    <div class="text-center mt-2">
        <p-skeleton width="12rem" height="1rem"></p-skeleton>
    </div>
</div>
} @else {

<div class="w-full md:w-2/3 mobile-padding mx-auto">
    <div class="flex justify-end mt-10 gap-4">
        <p-button (click)="goToDashboard()" label="Retour" icon="pi pi-angle-left" class="p-button-outlined"></p-button>
    </div>
</div>
<div class="card mt-8 w-full md:w-2/3 mobile-padding shadow-lg mx-auto">

    <div class="flex items-center justify-between mb-4">
        <div class="font-semibold text-xl">{{prediction().competition_name}}</div>

    </div>
    <div class="flex flex-row :text-center ">





        <div class="w-full md:w-5/12 flex flex-col items-center justify-center py-5">
            <img [src]="prediction().team_home_logo_id ?  prediction().team_home_logo_id  : prediction().team_home_logo"
                alt="PSG" width="100" />
            <span class="text-sm md:text-lg mt-2 font-semibold"> {{prediction().team_home_name}} </span>

            <div class="w-28 md:w-40 mt-2 bg-surface-300 dark:bg-surface-500 rounded-full overflow-hidden"
                style="height: 8px;">
                <div [ngClass]="{
                    'bg-red-500': prediction().confidence_team_home < 0.30, 
                    'bg-orange-500': prediction().confidence_team_home >= 0.3 && prediction().confidence_team_home < 0.6,
                    'bg-green-500': prediction().confidence_team_home >= 0.6
                    }" class="h-full" [style.width.%]="prediction().confidence_team_home * 100"></div>
            </div>
            <span [ngClass]="{
                    'text-red-500': prediction().confidence_team_home < 0.30,
                    'text-orange-500': prediction().confidence_team_home >= 0.3 && prediction().confidence_team_home < 0.6,
                    'text-green-500': prediction().confidence_team_home >= 0.6
                }" class=" mt-1 font-medium">{{prediction().confidence_team_home * 100}} %</span>
        </div>

        <div class="w-full md:w-2/12 flex flex-col items-center justify-center py-5">
            <div class="text-sm md:text-lg font-medium">{{prediction().event_date | date: 'MMM d, y'}}</div>
            <div class="text-gray-500">{{prediction().event_date | date: 'h:mm'}}</div>
        </div>



        <div class="w-full md:w-5/12 flex flex-col items-center justify-center py-5">
            <img [src]="prediction().team_away_logo_id ?  prediction().team_away_logo_id  : prediction().team_away_logo"
                alt="PSG" width="100" />
            <span class="mt-2 font-semibold"> {{prediction().team_away_name}} </span>

            <div class="w-28 md:w-40 mt-2 bg-surface-300 dark:bg-surface-500 rounded-full overflow-hidden"
                style="height: 8px;">
                <div [ngClass]="{
                    'bg-red-500': prediction().confidence_team_away < 0.30, 
                    'bg-orange-500': prediction().confidence_team_away >= 0.3 && prediction().confidence_team_away < 0.6,
                    'bg-green-500': prediction().confidence_team_away >= 0.6
                    }" class="h-full" [style.width.%]="prediction().confidence_team_away * 100"></div>
            </div>
            <span [ngClass]="{
                'text-red-500': prediction().confidence_team_away < 0.30,
                'text-orange-500': prediction().confidence_team_away >= 0.3 && prediction().confidence_team_away < 0.6,
                'text-green-500': prediction().confidence_team_away >= 0.6
            }" class=" mt-1 font-medium">{{prediction().confidence_team_away*100}} %</span>
        </div>

    </div>
    <div class="text-sm text-gray-600 mt-2 text-center max-w-xs mx-auto">
        {{prediction().event_name}}
    </div>
    <div class="text-sm text-gray-600 mt-2 text-center max-w-xs mx-auto">
        {{prediction().cote}}
    </div>
</div>

<div class="card p-8 max-w-6xl mx-auto shadow-lg">

    <div class="mb-8 text-end">
        <strong>Date de publication :</strong> {{prediction().created_at | date: 'dd/MM/yyyy'}}
    </div>
    <div class="mb-8">
        <h3 class="text-lg font-semibold mb-2">Analyse de l'expert</h3>
        <p class="text-gray-700 text-sm leading-relaxed whitespace-pre-line">
            {{prediction().analysis_text}}
        </p>
    </div>
    <div class="flex flex-col items-center text-center gap-4 mb-8">
        <div class="flex flex-col items-center text-center gap-4 mb-8">
            <div class="flex gap-4">
                <p-button [severity]="isPredictionLiked() === true ? 'success' : 'secondary'" icon="pi pi-thumbs-up"
                    (onClick)="likePrediction(true)" [outlined]="isPredictionLiked() !== true" [disabled]="loading()">
                </p-button>

                <p-button [severity]="isPredictionLiked() === false ? 'danger' : 'secondary'" icon="pi pi-thumbs-down"
                    (onClick)="likePrediction(false)" [outlined]="isPredictionLiked() !== false" [disabled]="loading()">
                </p-button>
            </div>

            <div *ngIf="!isLoadingStats() && likeStats(); else loadingStatsTemplate" class="text-gray-600 text-sm">
                👍 {{ likeStats()!.like_percentage }}% utilisateurs |
                👎 {{ likeStats()!.dislike_percentage }}% utilisateurs
            </div>

            <ng-template #loadingStatsTemplate>
                <div class="text-gray-600 text-sm">
                    <p-skeleton width="200px" height="1rem"></p-skeleton>
                </div>
            </ng-template>
        </div>
    </div>
</div>
}